import axios from "axios";
import { useSelector } from "react-redux";
import toast from "react-hot-toast";
import { loginSliceValue } from "../../redux/reducers/loginSlice";
import { useState } from "react";
import { useDispatch } from 'react-redux';
import useApi from '../useApi';
import { IAuditLog, IAuditLogRes } from './index.type';

type AuditLogParams = {
  patientId: string;
  fromDate: string;
  toDate: string;
  action: string;
  search: string;
};

const useFetchAuditLog = () => {
  const { userDetails } = useSelector(loginSliceValue);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [auditLog, setAuditLog] = useState<IAuditLog[]>([]);

  const { makeApiCall } = useApi({
    url: "/rtm/audit",
    method: "GET"
  });

  const getAuditLog = async ({
    patientId,
    fromDate,
    toDate,
    action,
    search
  }: AuditLogParams): Promise<IAuditLog[]> => {
    setLoading(true);
    setError(null);

    try {
      const queryParams = new URLSearchParams({
        patientId,
        fromDate,
        toDate,
        action,
        search: search || ''
      }).toString();

      const { response, error: apiError } = await makeApiCall<null, IAuditLogRes>(
        null,
        `/rtm/audit?${queryParams}`
      );

      if (apiError) {
        const errorMessage = apiError.msg || 'Unable to load audit logs. Please try again.';
        setError(errorMessage);
        toast.error(errorMessage);
        console.error('Error fetching audit logs:', apiError);
        return [];
      }

      if (response) {
        const logs = response.data?.data || [];
        setAuditLog(logs);
        return logs;
      }

      return [];
    } catch (error: any) {
      const errorMessage = 'Failed to fetch audit logs. Please try again.';
      setError(errorMessage);
      toast.error(errorMessage);
      console.error('Error in getAuditLog:', error);
      return [];
    } finally {
      setLoading(false);
    }
  };

  return { getAuditLog, loading, error, auditLog };
};

export default useFetchAuditLog;

